import React from 'react';
import theme from '../../theme';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  fullWidth = false,
  disabled = false,
  loading = false,
  icon = null,
  iconPosition = 'left',
  className = '',
  ...props 
}) => {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing[2],
    fontWeight: theme.typography.fontWeight.semibold,
    borderRadius: theme.borderRadius.full,
    transition: `all ${theme.transitions.base}`,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    width: fullWidth ? '100%' : 'auto',
    border: 'none',
    outline: 'none',
    textDecoration: 'none',
  };
  
  const variants = {
    primary: {
      backgroundColor: theme.colors.primary[500],
      color: theme.colors.text.primary,
      '&:hover': {
        backgroundColor: !disabled && theme.colors.primary[600],
      },
    },
    secondary: {
      backgroundColor: theme.colors.bg.card,
      color: theme.colors.text.primary,
      border: `1px solid ${theme.colors.border.default}`,
      '&:hover': {
        backgroundColor: !disabled && theme.colors.bg.hover,
        borderColor: !disabled && theme.colors.border.hover,
      },
    },
    ghost: {
      backgroundColor: 'transparent',
      color: theme.colors.text.secondary,
      '&:hover': {
        backgroundColor: !disabled && theme.colors.bg.hover,
        color: !disabled && theme.colors.text.primary,
      },
    },
    danger: {
      backgroundColor: theme.colors.error,
      color: theme.colors.text.primary,
      '&:hover': {
        backgroundColor: !disabled && '#c44040',
      },
    },
  };
  
  const sizes = {
    sm: {
      padding: `${theme.spacing[2]} ${theme.spacing[3]}`,
      fontSize: theme.typography.fontSize.sm,
    },
    md: {
      padding: `${theme.spacing[3]} ${theme.spacing[4]}`,
      fontSize: theme.typography.fontSize.base,
    },
    lg: {
      padding: `${theme.spacing[4]} ${theme.spacing[6]}`,
      fontSize: theme.typography.fontSize.lg,
    },
  };
  
  const style = {
    ...baseStyles,
    ...variants[variant],
    ...sizes[size],
  };
  
  const renderContent = () => {
    if (loading) {
      return (
        <>
          <span className="animate-spin">⟳</span>
          <span>Loading...</span>
        </>
      );
    }
    
    return (
      <>
        {icon && iconPosition === 'left' && <span>{icon}</span>}
        {children}
        {icon && iconPosition === 'right' && <span>{icon}</span>}
      </>
    );
  };

  return (
    <button
      className={`castle-button castle-button-${variant} castle-button-${size} ${className}`}
      style={style}
      disabled={disabled || loading}
      {...props}
    >
      {renderContent()}
    </button>
  );
};

export default Button;